import { createFormContext } from '@mantine/form';

import { SamplePlanFormV2Type } from 'store/projects/types';

export const [SamplePlanFormProvider, useSamplePlanFormContext, useSamplePlanForm] =
  createFormContext<SamplePlanFormV2Type, (values: SamplePlanFormV2Type) => SamplePlanFormV2Type>();
